import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useLibraryRequestDetails, useLibraryRequestPreview } from "../../custom-hooks/queries";
import { getLibraryRequestPreviewModalTitle } from "../../utils/libraryRequestPreview";
import WatermarkedPdfViewer from "./WatermarkedPdfViewer";

export default function LibraryRequestPreviewModal({
  open,
  onClose,
  requestId,
  allowFullReportPreview,
}) {
  const needsDetails = open && allowFullReportPreview === undefined;
  const { data: details } = useLibraryRequestDetails(requestId, needsDetails);
  const { data, isLoading, isError } = useLibraryRequestPreview(requestId, open);

  const resolvedAllowFull =
    allowFullReportPreview ?? details?.allow_full_report_preview ?? false;
  const title =
    allowFullReportPreview !== undefined || details
      ? getLibraryRequestPreviewModalTitle(resolvedAllowFull)
      : "Report Preview";

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-gray-500/75 backdrop-blur-sm" />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <DialogPanel className="relative w-full max-w-5xl rounded-lg bg-white shadow-xl">
            <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
              <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                {title}
              </DialogTitle>
              <button
                type="button"
                onClick={onClose}
                aria-label="Close preview"
                className="rounded-md p-1 text-gray-400 hover:text-gray-600"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
            <div className="max-h-[75vh] overflow-y-auto bg-gray-100 p-6">
              {isLoading && (
                <p className="py-10 text-center text-sm text-gray-500">Loading report…</p>
              )}
              {isError && (
                <p className="py-10 text-center text-sm text-red-600">
                  The report preview is not available.
                </p>
              )}
              {data && <WatermarkedPdfViewer data={data} />}
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
